import { usePersistentState } from '@/modules/shared/hooks/usePersistentState'
import { useState } from 'react'

export type BonusToolbarState = {
  automaticOvertimeCompensation: boolean
  zusPaidFromAverageGross: boolean
  domesticBusinessTripDateType: 'start' | 'end' | null
  displayBailiffDeduction: boolean
  displayEquivalent: boolean
  displayLeaveAdditionColumns: boolean
}

export const useBonusRewardsToolbar = () => {
  const [state, setState] = usePersistentState<BonusToolbarState>(
    'bonus-reward-toolbar',
    {
      automaticOvertimeCompensation: false,
      zusPaidFromAverageGross: false,
      domesticBusinessTripDateType: null,
      displayBailiffDeduction: false,
      displayEquivalent: false,
      displayLeaveAdditionColumns: false,
    },
  )
  const [modal, setModal] = useState<'print' | 'import' | string>('')

  const toggle = (key: keyof Omit<BonusToolbarState, 'domesticBusinessTripDateType'>) => {
    setState((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const setDomesticTripType = (value: 'start' | 'end') => {
    setState((prev) => ({
      ...prev,
      domesticBusinessTripDateType:
        prev.domesticBusinessTripDateType === value ? null : value,
    }))
  }

  const openModal = (name: 'print' | 'import') => setModal(name)
  const closeModal = () => setModal('')

  return {
    state,
    toggle,
    setDomesticTripType,
    modal,
    openModal,
    closeModal,
  }
}
